// extracted by mini-css-extract-plugin
export default {"EmployeeList":"EmployeeList_EmployeeList__O9Mcv"};